(() => {
  function initArchive(scope = document) {
    scope.querySelectorAll('[data-product-share]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const status = panel.querySelector('[data-release-share-status]');
      const fallback = panel.querySelector('.share-link-fallback');
      const copy = async () => {
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(panel.dataset.url);
          fallback.hidden = true;
          status.textContent = panel.dataset.copied;
        } catch {
          fallback.hidden = false;
          status.textContent = panel.dataset.manual;
          const input = fallback.querySelector('input');
          input.focus();
          input.select();
        }
      };
      panel.querySelector('[data-copy-release]').addEventListener('click', copy);
      panel.querySelector('[data-share-release]').addEventListener('click', async () => {
        status.textContent = '';
        if (!navigator.share) return copy();
        try { await navigator.share({ title: panel.dataset.title, url: panel.dataset.url }); }
        catch (error) { if (error.name !== 'AbortError') await copy(); }
      });
    });
    scope.querySelectorAll('[data-art-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const dialog = gallery.querySelector('dialog');
      if (!dialog) return;
      const slides = [...dialog.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...dialog.querySelectorAll('[data-gallery-thumb]')];
      const status = dialog.querySelector('[data-gallery-status]');
      const stage = dialog.querySelector('.gallery-stage');
      let current = 0;
      let opener;
      let startX = 0;
      let startY = 0;
      const select = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
        status.textContent = `${current + 1} / ${slides.length}`;
      };
      gallery.querySelectorAll('[data-gallery-open]').forEach(button => {
        button.addEventListener('click', () => {
          opener = button;
          select(Number(button.dataset.galleryOpen));
          dialog.showModal();
          document.body.classList.add('archive-gallery-open');
          dialog.querySelector('[data-gallery-close]').focus();
        });
      });
      dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(current - 1));
      dialog.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(current + 1));
      thumbs.forEach(button => button.addEventListener('click', () => select(Number(button.dataset.galleryThumb))));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          select(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      stage.addEventListener('touchstart', event => {
        startX = event.changedTouches[0].clientX;
        startY = event.changedTouches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', event => {
        const deltaX = event.changedTouches[0].clientX - startX;
        const deltaY = event.changedTouches[0].clientY - startY;
        if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) select(current + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
      dialog.addEventListener('click', event => {
        if (event.target === dialog || event.target === dialog.querySelector('.archive-lightbox-inner')) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('archive-gallery-open');
        opener?.focus();
      });
    });
  }
  initArchive();
  document.addEventListener('shopify:section:load', event => initArchive(event.target));
})();
